import React, { useState } from "react";
import { AuthContext } from "../../AuthContext";
import { useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import axios from "axios";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useContext } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const GOOGLE_CLIENT_ID = "253523671099-dnj950vf6nuq2jrk4ot0g4fhvbsct2b8.apps.googleusercontent.com";

function SignUp() {
  const [showPass, setShowPass] = useState(false);
  const [showPass2, setShowPass2] = useState(false);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    contactNo: "",
    password: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let newErrors = {};
    if (!formData.fullName.trim()) newErrors.fullName = "Full Name is required.";
    if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Valid Email is required.";
    if (!/^[6-9]\d{9}$/.test(formData.contactNo))
      newErrors.contactNo = "Enter a valid 10-digit Indian mobile number.";
    if (formData.password.length < 6)
      newErrors.password = "Password must be at least 6 characters long.";
    if (formData.password !== formData.confirmPassword)
      newErrors.confirmPassword = "Passwords do not match.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "contactNo") {
      if (!/^\d*$/.test(value)) return; 
    }
  
    setFormData({ ...formData, [name]: value });
  };

  const [isChecked, setIsChecked] = useState(false);
const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!isChecked) {
    toast.error("Please agree to the Terms of Service and Privacy Policy before proceeding.");
    return;
  }

  if (validateForm()) {
    setIsSubmitting(true); // Disable button

    try {
      const submissionData = {
        Named: formData.fullName,
        Email: formData.email,
        Cno: formData.contactNo,
        Jdate: new Date().toISOString().split("T")[0],
        Regmode: "Email",
        Pass: formData.password,
      };

      const response = await axios.post(
        "https://adhigyanam-e92bf1bbbdb1.herokuapp.com/registeruseremail",
        submissionData
      );

      if (response.data.success) {
        login(response.data.token);
        localStorage.setItem("userId", response.data.userId);

        setFormData({
          fullName: "",
          email: "",
          contactNo: "",
          password: "",
          confirmPassword: "",
        });
        setIsChecked(false); // Reset checkbox

        const redirectPath = localStorage.getItem("redirectAfterLogin");
        if (redirectPath) {
          localStorage.removeItem("redirectAfterLogin");
          window.location.href = redirectPath;
        } else {
          window.location.href = "/userdashboard";
        }

      } else {
        toast.error(response.data.message);
      }

    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Sorry! Account already exists with Email / Contact No.");
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  }
};
  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const { credential } = credentialResponse;
      
      const response = await axios.post("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/google-login", { token: credential });

      if (response.data.success) {
        
        login(response.data.token);
        localStorage.setItem("userId", response.data.userId); // Store user ID
       

        const redirectPath = localStorage.getItem("redirectAfterLogin");
if (redirectPath) {
  localStorage.removeItem("redirectAfterLogin");
  window.location.href = redirectPath;
} else {
  window.location.href = "/userdashboard";
}
   
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Google login error:", error);
      toast.error("Google authentication failed.");
    }
  };
  const { login } = useContext(AuthContext);

  // ---------- Policy popups (iframe version) ----------
const [showTermsModal, setShowTermsModal] = useState(false);
const [showPrivacyModal, setShowPrivacyModal] = useState(false);

const openTerms = () => setShowTermsModal(true);
const openPrivacy = () => setShowPrivacyModal(true);
const closeAllModals = () => {
  setShowTermsModal(false);
  setShowPrivacyModal(false);
};

useEffect(() => {
  const handleEsc = (e) => {
    if (e.key === "Escape") closeAllModals();
  };
  document.addEventListener("keydown", handleEsc);
  return () => document.removeEventListener("keydown", handleEsc);
}, []);

  return (
    <section className="account-section" style={{
      backgroundImage: `url(${require("../../assets/siteimages/astrobackground45.png")})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      minHeight: "100vh", // full screen height
    }}>
   
      <div className="tf-container" >
        <div className="row">
          <Tabs className="wd-form-login tf-tab">
          <h5 style={{fontSize:"32px"}}>Create New Account</h5>
          <p style={{marginBottom:"20px"}}>Use the following form to create a new account with us.</p>
         
           <TabList className="menu-tab">
             <NavLink to="/registration" className="ct-tab" style={{width:"100%"}}>
               <Tab style={{width:"100%"}}>New User</Tab>
             </NavLink>
             <NavLink to="/astrologerreg" className="ct-tab"  style={{width:"100%"}}>
               <Tab style={{width:"100%"}}>Astrologer</Tab>
             </NavLink>
           </TabList>
            <div className="content-tab">
              <TabPanel className="inner animation-tab">
              <Link to="/otplogin" className="btn-social">
                                  Continue with OTP
                                </Link>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <GoogleLogin onSuccess={handleGoogleSuccess} onError={() => console.log("Login Failed")} />
    </GoogleOAuthProvider>
                                <p className="line-ip" style={{marginTop:"20px"}}>
                                  <span>or</span>
                                </p>
              <form onSubmit={handleSubmit}>
                  <div className="ip">
                    <label style={{ fontWeight: "bold" }}>Full Name&nbsp;<span>*</span></label>
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      placeholder="Full Name"
                      style={{ backgroundColor: "#fafafa" }}
                    />
                    {errors.fullName && <p className="error">{errors.fullName}</p>}
                  </div>

                  <div className="ip">
                    <label style={{ fontWeight: "bold" }}>Email address&nbsp;<span>*</span></label>
                    <input
                      type="text"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Email Address"
                      style={{ backgroundColor: "#fafafa" }}
                    />
                    {errors.email && <p className="error">{errors.email}</p>}
                  </div>

                  <div className="ip">
                    <label style={{ fontWeight: "bold" }}>Contact No.&nbsp;<span>*</span></label>
                    <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                    <span style={{ position: "absolute", left: "15px", color: "#555", fontWeight:"bold" }}>+91</span>
                    <input
  type="text"
  name="contactNo"
  value={formData.contactNo}
  onChange={handleChange}
  inputMode="numeric"
  pattern="\d*"
  maxLength="10"
  placeholder="Contact No."
  style={{ backgroundColor: "#fafafa", paddingLeft:"50px" }}
/>
</div>
                    {errors.contactNo && <p className="error">{errors.contactNo}</p>}
                  </div>

                  <div className="ip">
                    <label style={{ fontWeight: "bold" }}>Create Password&nbsp;<span>*</span></label>
                    <div className="inputs-group auth-pass-inputgroup">
                      <input
                        type={showPass ? "text" : "password"}
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        placeholder="New Password"
                        className="input-form password-input"
                        style={{ backgroundColor: "#fafafa" }}
                      />
                      <Link
                        className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"}`}
                        onClick={() => setShowPass(!showPass)}
                      />
                    </div>
                    {errors.password && <p className="error">{errors.password}</p>}
                  </div>

                  <div className="ip">
                    <label style={{ fontWeight: "bold" }}>Confirm Password&nbsp;<span>*</span></label>
                    <div className="inputs-group auth-pass-inputgroup">
                      <input
                        type={showPass2 ? "text" : "password"}
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        placeholder="Confirm Password"
                        className="input-form password-input"
                        style={{ backgroundColor: "#fafafa" }}
                      />
                      <Link
                        className={`password-addon ${showPass2 ? "icon-eye" : "icon-eye-off"}`}
                        onClick={() => setShowPass2(!showPass2)}
                      />
                    </div>
                    {errors.confirmPassword && <p className="error">{errors.confirmPassword}</p>}
                  </div>
                  <div className="group-ant-choice" style={{marginBottom:"10px"}}>
                <div className="sub-ip">
                <input
  type="checkbox"
  checked={isChecked}
  onChange={(e) => setIsChecked(e.target.checked)}
/> 
                  By clicking 'Sign Up' you agree to adhigyanam.com's{" "}
<button
  type="button"
  onClick={openTerms}
  style={{ background: "none", border: "none", color: "#14a077", padding: 0, cursor: "pointer", width:"auto", display:"inline-block", fontWeight:"normal", fontSize:"14px", lineHeight:"14px" }}
>
  Terms Of Service
</button>{" "}
and{" "}
<button
  type="button"
  onClick={openPrivacy}
  style={{ background: "none", border: "none", color: "#14a077", padding: 0, cursor: "pointer", width:"auto", display:"inline-block", fontWeight:"normal", fontSize:"14px", lineHeight:"14px" }}
>
  Privacy Policy
</button>.
                </div>
              </div>
                 <button type="submit" disabled={isSubmitting}>
  {isSubmitting ? "Please Wait..." : "Sign Up"}
</button>
                   <div className="group-ant-choice" style={{marginTop:"15px"}}>
                                                <div className="sub-ip">
                                                
                                  Registered Already? <Link to="/login">Login Now</Link>
                               
                                                </div>
                                                <Link to="/otplogin" className="forgot">
                                                  Login with Mobile No.
                                                </Link>
                                              </div>
                </form>
                <style>
{`
  .Toastify__close-button {
    display: none;
  }

  .Toastify__toast {
    position: relative;
    padding-right: 30px;
  }
`}
</style>
           <ToastContainer position="bottom-center"
  autoClose={5000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover />
              </TabPanel>
            </div>
          </Tabs>
        </div>
      </div>
      {/* ----------------- Policy Modals (iframe version) ----------------- */}
{(showTermsModal || showPrivacyModal) && (
  <div
    className="policy-overlay"
    onClick={closeAllModals}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.6)",
      zIndex: 2000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 24,
    }}
  >
    <div
      role="dialog"
      aria-modal="true"
      onClick={(e) => e.stopPropagation()}
      style={{
        width: "100%",
        maxWidth: 900,
        height: "80vh",
        background: "#fff",
        borderRadius: 8,
        overflow: "hidden",
        boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      

      <iframe
        src={showTermsModal ? "/policy1" : "/policy2"}
        title={showTermsModal ? "Terms of Service" : "Privacy Policy"}
        style={{ flex: 1, border: "none", width: "100%", height: "100%" }}
      />

      <div
        style={{
          textAlign: "right",
          padding: "10px 20px",
          borderTop: "1px solid #ddd",
        }}
      >
        <button
          onClick={closeAllModals}
          style={{
            background: "#14a077",
            color: "#fff",
            border: "none",
            padding: "8px 16px",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Close
        </button>
      </div>
    </div>
  </div>
)}
{/* -------------------------------------------------- */}
    </section>
  );
}

export default SignUp;
